import { render, staticRenderFns } from "./BulkCallDetails.vue?vue&type=template&id=16aa5df0&scoped=true"
import script from "./BulkCallDetails.vue?vue&type=script&lang=js"
export * from "./BulkCallDetails.vue?vue&type=script&lang=js"
import style0 from "./BulkCallDetails.vue?vue&type=style&index=0&id=16aa5df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aa5df0",
  null
  
)

export default component.exports